import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IOperationsList, IDefectList, TOperationIssueAndMarkedLocations } from '@monorepo/types';

@Component({
  selector: 'monorepo-filter-masterdata-list',
  templateUrl: './filter-masterdata-list.component.html',
  styleUrls: ['./filter-masterdata-list.component.scss'],
})
export class FilterMasterdataListComponent implements OnInit {
  @Input() lists: IOperationsList[] = [];
  selectedLists: (IOperationsList | IDefectList)[] = [];
  @Input() preSelectedLists: (IOperationsList | IDefectList)[] = [];
  @Input() title = '';
  @Input() showCategoryId = false;
  backArrow = '/assets/md-point/header-back-arrow.svg';
  constructor(private modalCtrl: ModalController) {}

  ngOnInit(): void {
    this.selectedLists = this.preSelectedLists;
  }

  handleOperationOrRejectReasonSelection(list: (IOperationsList | IDefectList | TOperationIssueAndMarkedLocations)[]) {
    this.selectedLists = list as (IOperationsList | IDefectList)[];
  }

  handleSelectAll() {
    if (this.selectedLists.length === this.lists.length) this.selectedLists = [];
    else this.selectedLists = this.lists;
  }

  handleCancel() {
    this.modalCtrl.dismiss();
  }

  handleApply() {
    this.modalCtrl.dismiss(this.selectedLists);
  }
}
